var detailsToggler = document.getElementById('js-spec-details-toggler');
var details = document.getElementById('js-spec-details');

if (detailsToggler) {
  detailsToggler.addEventListener('click', function () {
    detailsToggler.classList.toggle('is-expanded');
    details.classList.toggle('is-expanded');
  });
}

// Toggles between meters and feets
var unitToggler = document.getElementById('js-unit-toggler');
if (unitToggler) {
  unitToggler.addEventListener('click', function () {
    details.classList.toggle('show-feets');
  });
}
